import { getAccessToken } from "./authStorage";
import { isClinicPortal, redirectToClinicPortal } from "./portalHost";
import { getPortalByRole } from "./portalTypes";
import { normalizeRole } from "./roles";

export const AUTH_PATH = "/auth";

/** Единая страница входа для всех ролей клуба */
export const UNIFIED_LOGIN_PATH = "/login";

/** Единая страница сброса пароля */
export const UNIFIED_FORGOT_PASSWORD_PATH = "/forgot-password";

export function getDashboardPath(role) {
  const r = normalizeRole(role);
  if (!isClinicPortal()) {
    switch (r) {
      case "owner":
        return "/account";
      case "admin":
        return "/account";
      case "trainer":
        return "/clinic/doctor";
      case "client":
        return "/clinic/patient";
      default:
        return "/";
    }
  }
  return getPortalByRole(r).app;
}

export function getLoginPath(role) {
  if (!isClinicPortal()) {
    return AUTH_PATH;
  }
  return UNIFIED_LOGIN_PATH;
}

export function getAuthPath() {
  return isClinicPortal() ? UNIFIED_LOGIN_PATH : AUTH_PATH;
}

/** После регистрации клуба — сразу в админку на поддомене. */
export function openRegisteredClubAdmin(subdomain, accessToken) {
  const sub = String(subdomain || "").trim().toLowerCase();
  if (!sub) return;
  redirectToClinicPortal(
    sub,
    getPortalByRole("owner").app,
    accessToken || getAccessToken(),
  );
}
